module.exports = __webpack_public_path__ + "img/60.8.TSS.97e4caeb.png";